// import React from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useAuth } from '../../context/AuthContext';
// import { useToast } from '../../context/ToastContext';
// import './TopBar.css';

// const TopBar = ({ pageTitle }) => {
//     const { authUser, logout } = useAuth();
//     const { showToast } = useToast();
//     const navigate = useNavigate();

//     const getRoleLabel = () => {
//         if (!authUser) return '';
//         const labels = {
//             admin: 'Admin',
//             manager: 'Pump Manager',
//             agent: 'Agent',
//         };
//         return labels[authUser.user_type] || authUser.user_type;
//     };

//     const getUserInitials = () => {
//         if (!authUser || !authUser.name) return 'U';
//         return authUser.name
//             .split(' ')
//             .map(n => n[0])
//             .join('')
//             .toUpperCase()
//             .slice(0, 2);
//     };

//     const handleLogout = () => {
//         logout();
//         showToast('Logged out successfully', 'success');
//         navigate('/login');
//     };

//     return (
//         <header className="topbar">
//             <div className="topbar-content">
//                 <h1 className="topbar-title">{pageTitle}</h1>
//                 <div className="topbar-right">
//                     <div className="topbar-role">
//                         <span className="topbar-role-badge">{getRoleLabel()}</span>
//                     </div>
//                     <div className="topbar-user">
//                         <div className="topbar-avatar">{getUserInitials()}</div>
//                         <span className="topbar-username">{authUser?.name || 'User'}</span>
//                     </div>
//                     <button
//                         onClick={handleLogout}
//                         className="logout-button"
//                     >
//                         Logout
//                     </button>
//                 </div>
//             </div>
//         </header>
//     );
// };

// export default TopBar;


import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useToast } from '../../context/ToastContext';
import './TopBar.css';

const TopBar = ({ pageTitle }) => {
  const { authUser, logout } = useAuth();
  const { showToast } = useToast();
  const navigate = useNavigate();

  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const getRoleLabel = () => {
    if (!authUser) return '';
    const labels = {
      admin: 'Admin',
      manager: 'Pump Manager',
      agent: 'Agent',
    };
    return labels[authUser.user_type] || authUser.user_type;
  };

  const getUserInitials = () => {
    if (!authUser || !authUser.name) return 'U';
    return authUser.name
      .split(' ')
      .map(n => n[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  const handleLogoutClick = () => {
    // open confirmation modal instead of logging out immediately
    setIsLogoutModalOpen(true);
  };

  const handleConfirmLogout = async () => {
    try {
      setIsLoggingOut(true);
      // if logout returns a promise, await it
      await logout();
      showToast?.('Logged out successfully', 'success');
      navigate('/login');
    } catch (err) {
      console.error('Logout failed', err);
      showToast?.('Failed to logout. Try again.', 'error');
    } finally {
      setIsLoggingOut(false);
      setIsLogoutModalOpen(false);
    }
  };

  const handleCancelLogout = () => {
    setIsLogoutModalOpen(false);
  };

  // keyboard: close modal on Escape
  useEffect(() => {
    if (!isLogoutModalOpen) return;
    const onKey = (e) => {
      if (e.key === 'Escape') setIsLogoutModalOpen(false);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [isLogoutModalOpen]);

  return (
    <header className="topbar">
      <div className="topbar-content">
        <h1 className="topbar-title">{pageTitle}</h1>
        <div className="topbar-right">
          <div className="topbar-role">
            <span className="topbar-role-badge">{getRoleLabel()}</span>
          </div>
          <div className="topbar-user">
            <div className="topbar-avatar">{getUserInitials()}</div>
            <span className="topbar-username">{authUser?.name || 'User'}</span>
          </div>
          <button onClick={handleLogoutClick} className="logout-button">
            Logout
          </button>
        </div>
      </div>

      {/* Simple confirmation modal */}
      {isLogoutModalOpen && (
        <div className="logout-modal-overlay" onMouseDown={handleCancelLogout}>
          <div
            className="logout-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="logout-modal-title"
            onMouseDown={(e) => e.stopPropagation()}
          >
            <h3 id="logout-modal-title">Confirm Logout</h3>
            <p>Are you sure you want to logout?</p>

            <div className="logout-modal-actions">
              <button
                type="button"
                className="btn btn-outline"
                onClick={handleCancelLogout}
                disabled={isLoggingOut}
              >
                No
              </button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={handleConfirmLogout}
                disabled={isLoggingOut}
              >
                {isLoggingOut ? 'Logging out…' : 'Yes, Logout'}
              </button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default TopBar;

